import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LangContext";

export default function SectionHead({ title, sub, to, kicker }) {
  const { t } = useLang();
  return (
    <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
      <div>
        {kicker && <p className="mb-2 text-xs font-bold uppercase tracking-[0.2em] text-[#D97706]">{kicker}</p>}
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{title}</h2>
        {sub && <p className="mt-2 text-base text-slate-500">{sub}</p>}
      </div>
      {to && <Link to={to} className="group inline-flex items-center gap-1 text-sm font-bold text-[#064E3B] hover:underline">{t("see_all")}<ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></Link>}
    </div>
  );
}

export const PageHero = ({ title, sub, children }) => (
  <section className="mx-auto max-w-7xl px-4 pt-12 pb-8 sm:px-6 lg:px-8">
    <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 fade-up [overflow-wrap:anywhere]">{title}</h1>
    {sub && <p className="mt-3 max-w-2xl text-base md:text-lg text-slate-500 fade-up" style={{ animationDelay: "80ms" }}>{sub}</p>}
    {children}
  </section>
);
